import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;

export const loginUser = async (credentials) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/signup/login`,
      credentials,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const registerUser = async (userData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/signup/create`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const forgotPasswordHandler = async (values) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/signup/forgot-password`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const verfiyEmail = async (values) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/signup/email-verification`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const otpVerifyHandler = async (email, otp) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/signup/check-otp`,
      {
        email,
        otp,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const otpVerifyEmailHandler = async (email, otp) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/signup/email-verify-otp`,
      {
        email,
        otp,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const newPasswordHandler = async (email, newPassword) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/signup/new-password`,
      {
        email,
        newPassword,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};
